
import React from 'react';

import CategoryCard from './CategoryCard';

const Categories = () => {
  return <CategoryCard />;
};

export default Categories;
